import { searchParametersActions } from 'features/searchResultsFacets';

const fetchRequestListByAction = new Set([
  searchParametersActions.fetchBuilderReviews.type,
  searchParametersActions.fetchConsumerPromos.type,
  searchParametersActions.fetchActiveAdult.type,
  searchParametersActions.fetchExcludeActiveAdult.type,
  searchParametersActions.fetchAnyCommunities.type,
  searchParametersActions.fetchBathrooms.type,
  searchParametersActions.fetchBedrooms.type,
  searchParametersActions.fetchLocations.type,
  searchParametersActions.fetchMapLocations.type,
  searchParametersActions.fetchPrice.type,
  searchParametersActions.fetchResultsType.type,
  searchParametersActions.fetchLivingAreas.type,
  searchParametersActions.fetchStories.type,
  searchParametersActions.fetchPrimaryBedroom.type,
  searchParametersActions.fetchGarages.type,
  searchParametersActions.fetchAmenities.type,
  searchParametersActions.fetchMoveInDateByStatus.type,
  searchParametersActions.clearMoveInDateFilter.type,
  searchParametersActions.clearFilters.type,
  searchParametersActions.fetchMoveInDateByRange.type,
  searchParametersActions.fetchCustom.type,
  searchParametersActions.fetchSingleFamily.type,
  searchParametersActions.fetchLuxury.type,
  searchParametersActions.fetchCondosAndTownHomes.type,
  searchParametersActions.fetchBrandId.type,
  searchParametersActions.fetchViewBrandResults.type,
  searchParametersActions.fetchViewBrandMarketResults.type,
  searchParametersActions.fetchRvGarages.type,
  searchParametersActions.fetchGolfCourse.type,
  searchParametersActions.fetchMarketingStatus.type,
  searchParametersActions.fetchPriceReduction.type,
  searchParametersActions.fetchModelHome.type,
  searchParametersActions.allOptions.type,
  searchParametersActions.fetchHomeOwnersAssociationFee.type,
  searchParametersActions.fetchInteractiveSitePlanResults.type,
]);

/**
 * validateIfFetchRequest: Checks if the fetch request should be triggered according the action.
 * @param {string} actionType Name of the action.
 * @returns A boolean value indicating if the fetch request should be triggered according to action.
 */
const validateIfFetchRequest = (actionType) =>  fetchRequestListByAction.has(actionType);

export default validateIfFetchRequest;
